'use client';

/**
 * Redux Provider Component
 * Wraps the application with Redux store provider
 */

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from '@/store/store';
import PostHogProvider from './PostHogProvider';

export default function ReduxProvider({ children }: { children: React.ReactNode }) {
  return (
    <Provider data-component-id="src/components/providers/ReduxProvider.tsx:15:4" data-component-path="src/components/providers/ReduxProvider.tsx" data-component-line="15" data-component-end-line="19" data-component-file="ReduxProvider.tsx" data-component-name="Provider" data-component-content="%7B%22elementName%22%3A%22Provider%22%7D" store={store}>
      <PersistGate data-component-id="src/components/providers/ReduxProvider.tsx:16:6" data-component-path="src/components/providers/ReduxProvider.tsx" data-component-line="16" data-component-end-line="18" data-component-file="ReduxProvider.tsx" data-component-name="PersistGate" data-component-content="%7B%22elementName%22%3A%22PersistGate%22%7D" loading={null} persistor={persistor}>
        <PostHogProvider data-component-id="src/components/providers/ReduxProvider.tsx:17:8" data-component-path="src/components/providers/ReduxProvider.tsx" data-component-line="17" data-component-end-line="17" data-component-file="ReduxProvider.tsx" data-component-name="PostHogProvider" data-component-content="%7B%22elementName%22%3A%22PostHogProvider%22%7D">{children}</PostHogProvider>
      </PersistGate>
    </Provider>
  );
}
